import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAmazonPay, faApplePay, faGooglePay, faPaypal } from '@fortawesome/free-brands-svg-icons';
import { faDollarSign, faWallet } from '@fortawesome/free-solid-svg-icons';


const getIcon = (platform) => {
    switch (platform) {
        case 'amazonPay':
            return faAmazonPay;
        case 'applePay':
            return faApplePay;
        case 'googlePay':
            return faGooglePay;
        case 'paypal':
            return faPaypal;
        case 'squareCash':
            return faDollarSign;
        case 'samsungPay':
            return faWallet;
        case 'venmo':
            return faWallet;
        case 'zelle':
            return faWallet;
        default:
            return faWallet;
    }
};

const PaymentAccount = (props) => {
    const { paymentPlatformKey: platform, paymentAccountDisplayName: name, paymentAccountUrl: link } = props.paymentAccount;
    const icon = getIcon(platform);

    return (
        <a href={link} target="_blank" rel="noreferrer" title={name}
            style={{
                display: 'block',
                marginBottom: 3,
            }}>
            <FontAwesomeIcon icon={icon} fontSize={'1.5rem'} style={{
                color: 'gray',
                marginRight: 5,
            }} />
        </a>
    );
};

export default PaymentAccount;